import api from "@/lib/api";
import type {
  DocsListParams,
  ApiDoc,
  DocCreationPayload,
  DocumentationsListParams,
  ApiDocumentation,
} from "../types";
import type { PaginatedQueryResult } from "@/types";

const DOCS_ENDPOINTS = {
  LIST: "/cms/docs/",
  CREATE: "/cms/docs/",
  DETAIL: (id: string) => `/cms/docs/${id}/`,
  DOCUMENTATIONS: "/documentation/",
};

export class DocsHttpRepository {
  async fetchList(
    params?: DocsListParams,
  ): Promise<PaginatedQueryResult<ApiDoc>> {
    const result = await api.get(DOCS_ENDPOINTS.LIST, { params });
    return result.data;
  }

  async fetchOne(id: string): Promise<ApiDoc> {
    const result = await api.get(DOCS_ENDPOINTS.DETAIL(id));
    return result.data;
  }

  async create(payload: DocCreationPayload): Promise<ApiDoc> {
    const result = await api.post(DOCS_ENDPOINTS.CREATE, payload);
    return result.data;
  }

  async update(
    id: string,
    payload: Partial<DocCreationPayload>,
  ): Promise<ApiDoc> {
    const result = await api.patch(DOCS_ENDPOINTS.DETAIL(id), payload);
    return result.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(DOCS_ENDPOINTS.DETAIL(id));
  }

  async fetchDocumentations(
    params?: DocumentationsListParams,
  ): Promise<PaginatedQueryResult<ApiDocumentation>> {
    const result = await api.get(DOCS_ENDPOINTS.DOCUMENTATIONS, { params });
    return result.data;
  }
}
